import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from '../modules/active_modal';

import ModalOrderSummaryItem  from './ModalOrderSummaryItem.jsx';
import CustomerAddress        from './CustomerAddress.jsx';


class ModalOrderSuccess extends Component {

  render() {
    let {dispatch, store, customer, lastOrderCart} = this.props;
    // TODO: figure out how to calculate when credits were used (vs. promos or other free book methods)
    let oLastOrderCart = lastOrderCart;
    let oMostRecentOrder = (customer && customer.status === 'Active' && customer.order_history && customer.order_history.length > 0) ? customer.order_history[0] : {};
    let oCartProducts    = '';
    let nOrderTotal      = parseFloat(oMostRecentOrder.grand_total) || 0;
    let nOrderSubtotal   = parseFloat(oMostRecentOrder.sub_total) || 0;
    let nOrderTax        = parseFloat(oMostRecentOrder.tax_amount) || 0;
    let oCreditUsed      = <div />;
    let reading          = store.tla !== "DVD" ? "reading" : "viewing";

    if (oLastOrderCart.items) {
      oCartProducts = oLastOrderCart.items.map((oItem, i) => {
        return (
          //old orders have dup items. mmmid might not be unique enough
          <ModalOrderSummaryItem
            key      = {'OrderSummary' + (oItem && oItem.mmid ? oItem.mmid + '_' + i : i)}
            index    = {i}
            product  = {oItem}
            order    = {oMostRecentOrder}
            lastOrderCart = {oLastOrderCart} />
        );
      });
    }

    if( store.type === "Neglite" )
      oCreditUsed = (
        <div className="clearfix">
          <div className="float-left">Credits Used</div>
          <div className="float-right">{!isNaN(Math.abs(oMostRecentOrder.credit_balance_change)) ? Math.abs(oMostRecentOrder.credit_balance_change) : '[information unavailable]'}</div>
        </div>
      )

    return (
      <div>
        <div className="modal-header content-max-width">
          <div className="button-wrapper">
            <button className="btn-secondary" onClick={() => dispatch(closeModal())}>Continue shopping</button>
          </div>
        </div>
        <div className="modal-body content-max-width">
          <div className="col-70 center">
            <div className="thanks-wrapper">
              <h2 className="center">Thank You For Your Order</h2>
              <p className="center">
              You will receive an email shortly with your order details and a shipment tracking number. Happy {reading}!
              </p>
              <div className="logo-icon-wrapper">
                <img src={"/images/" + store.tla.toLowerCase() + "/icon-logo.svg"} />
              </div>
            </div>
          </div>
          <div className="col-30 cart-account-info">
            <h3 className="alt">Order Summary</h3>
            <table className="cart-order-items">
              <tbody>
                {oCartProducts}
              </tbody>
            </table>
            <div className="cart-order-summary">
              <div className="section" id="cart-totals">
                {oCreditUsed}
                <div className="clearfix">
                  <div className="float-left">Subtotal</div>
                  <div className="float-right">${nOrderSubtotal.toFixed(2)}</div>
                </div>
                <div className="clearfix">
                  <div className="float-left">Tax</div>
                  <div className="float-right">${nOrderTax.toFixed(2)}</div>
                </div>
                <div className="clearfix">
                  <div className="float-left">Shipping</div>
                  <div className="float-right">{(oMostRecentOrder.shipping_amount === 0 ) ? 'FREE' : '$' + oMostRecentOrder.shipping_amount }</div>
                </div>
                <div className="clearfix total">
                  <div className="float-left"><strong>Total</strong></div>
                  <div className="float-right"><strong>${nOrderTotal.toFixed(2)}</strong></div>
                </div>
              </div>
            </div>
            <CustomerAddress  />
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'store': state.store,
      'customer': state.customer,
      'lastOrderCart': state.lastOrderCart
    };
}

export default connect(mapStateToProps)(ModalOrderSuccess);


// WEBPACK FOOTER //
// ./src/components/ModalOrderSuccess.jsx